/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clipboard_Copy_Errordescription1Inputs */

const en_clipboard_copy_errordescription1 = /** @type {(inputs: Clipboard_Copy_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy to clipboard. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to copy to clipboard. Please try again." |
*
* @param {Clipboard_Copy_Errordescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_errordescription1 = /** @type {((inputs?: Clipboard_Copy_Errordescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_Errordescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_clipboard_copy_errordescription1(inputs)
});
export { clipboard_copy_errordescription1 as "clipboard_copy_errorDescription" }